
import Select, { components } from "react-select";
import { useEffect, useMemo, useState } from "react";
import { STYLES_URL } from "../../helpers/url_api_helper";
import './style.scss';

const normalizeStylesItems = (items) =>
	items.map((item) => ({
		value: item.id,
		label: item.title,
	}));
const StyleSelect = ({ value, onChange, editable }) => {
  const [style, setStyle] = useState([]);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const CustomClear = (props) => (
    <components.ClearIndicator {...props}>
      <i
        className="fas fa-times"
        style={{ fontSize: "14px", color: "#888" }}
      />
    </components.ClearIndicator>
  );

	const customStyles = {
    singleValue: (base) => ({
      ...base,
      color: editable ? "#0576B960" : "#0576B9",
    }),
    placeholder: (base) => ({
      ...base,
      color: "#9599AD",
      fontWeight: "400",
    }),
    control: (base, state) => ({
      ...base,
      backgroundColor: state.hasValue ? "#EFF2F7" : "#FFF",
    }),
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
  };  

  useEffect(() => {
    let isMounted = true;

    const fetchStyle = async () => {
      setLoading(true);
      setError("");

      try {
        const stylesData = await STYLES_URL.getStyleAll();

        if (isMounted) {
          setStyle(normalizeStylesItems(stylesData));
        }
      } catch (error) {
        if (isMounted) {
          setError("Error fetching styles");
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    fetchStyle();
    return () => {
      isMounted = false;
    };
  }, []);

  const selectedValue = useMemo(() => {
        if (!value) return null;
    
        return style.find(
          (style) => style.value === value.value
        ) || null;
      }, [value, style]);

  return (
    <>
      <Select
        className="filter-select select-style"
        components={{ ClearIndicator: CustomClear }}
        options={style}
        value={selectedValue}
        onChange={onChange}
        placeholder={loading ? "Loading..." : "Select a style"}
        isClearable
        styles={customStyles}
        isDisabled={loading || editable}
        menuPortalTarget={document.body}
      />
    {error && <small className="text-danger">{error}</small>}
    </>
  );
};

export default StyleSelect;
